export default __webpack_public_path__ + "static/tag-do-4-light-3d2537d4ea730b4e3f1ee9c08b0d3baf.png";